import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";

const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { stateData } from "@/constants/electionConfig";
import OldElectionScreen from "@/screens/OldStateElection";

export default function ElectionTab({
  latestStoryData = null,
  latestVideoData = null,
  categoryNewsListData = null,
  constituencyListData = null,
  candidateData = null,
  constHindiName = null,
  constituencyDetailData = null,
  electionCategory = null,
}) {
  const isMobileDevice = useIsMobile();
  let metaData = {
    title: `${constHindiName} विधानसभा सीट परिणाम or ${candidateData?.[0]?.ac_name} Assembly Election Results 2024 | ${candidateData?.[0]?.candidate_h}`,
    description: `${candidateData?.[0]?.ac_name} ${candidateData?.[0]?.ac_name} Vidhan Sabha Elections Results 2024, ${candidateData?.[0]?.candidate_h} Constituency Seat - NewsTak.in`,
    keywords: `${constHindiName} ${candidateData?.[0]?.ac_name} Election Results: Latest Updates On ${candidateData[0]?.candidate} Constituency Seat ${candidateData?.[0]?.candidate_h}, ${candidateData?.[0]?.party_h}   उम्‍मीदवार के नाम,  चुनाव की खबरें, Constituency Seat – NewsTak.in`,
  };
  // console.log("candidateData", candidateData);
  const state_data = stateData[electionCategory];
  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <OldElectionScreen
          // electionPath="delhi-assembly/constituency-list"
          electionPath={`${electionCategory}/constituency-list`}
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          constituencyListData={constituencyListData}
          candidateData={candidateData}
          constHindiName={constHindiName}
          electionPassedCategory={
            state_data?.constituencies?.electionPassedCategory
          } //'delhi-assembly'
          stateName={state_data?.constituencies?.state} //"Delhi"
          stateHindi={state_data?.constituencies?.stateHindi} //"महाराष्ट्र"
          metaData={metaData}
          constituencyDetailData={constituencyDetailData}
          masterKey={state_data?.masterConfigKey}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const electionCategory = ctx?.params?.stateElection; //ctx?.params?.category === "election";

  if (!electionCategory) {
    // console.log("electionCategory =========", electionCategory);
    return {
      notFound: true,
    };
  }
  const { stateData } = await import("@/constants/electionConfig");

  if (!stateData[electionCategory]) {
    // console.log("stateData ==========", stateData);
    return {
      notFound: true,
    };
  }
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;

    url = url.split("/constituencies")[0];
    console.log("url ====", url);
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { MasterConfigContext } = await import(
      "@/context/MasterConfigContext"
    );
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    const masterConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    let electionConfig = masterConfig?.data;

    // const electionConfig = useContext(MasterConfigContext);

    // console.log("the elction config is" , electionConfig)

    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    const state_name =
      stateData[electionCategory]?.constituencies?.state?.toLowerCase();
    const year =
      masterConfigData?.[stateData[electionCategory]["masterConfigKey"]]
        ?.constDetailYear;
    console.log("year", year);
    let constituencyListData = null;

    let constituencyUrl = `https://akm-img-a-in.tosshub.com/sites/elections/${year}/assembly/json/state-master/${state_name}-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (data) => {
        const data1 = await data.json();
        // console.log("constituencyListData", data1?.data);
        constituencyListData = data1?.data;
      })
      .catch((err) => {
        console.log(err);
        constituencyListData = null;
      });

    let constId = ctx?.resolvedUrl?.split("?")[0].split("-").pop();

    let constHindiName =
      constituencyListData &&
      constituencyListData?.filter(
        (item) => parseInt(item?.cons_id) === parseInt(constId)
      )[0]?.cons_name_hi;

    let candidateData = null;
    let constituencyDetailData = null;

    let candidateUrl = `https://akm-img-a-in.tosshub.com/sites/elections/${year}/assembly/json/constituency/${state_name}/${constId}.json`;

    await fetch(candidateUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (data) => {
        const tempCand = await data.json();

        candidateData = tempCand?.data?.candidate;
        constituencyDetailData = tempCand?.data;
        // console.log("constituencyDetailData", constituencyDetailData);
      })
      .catch((err) => {
        console.log(err);
        candidateData = null;
        constituencyDetailData = null;
      });

    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      //  faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: page,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);
    // console.log("constituencyDetailData", latestStoryData);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        constituencyListData,
        candidateData,
        constHindiName,
        constituencyDetailData,
        electionCategory,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
